import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const SIGNUP_URL =
  process.env.REACT_APP_SIGNUP_URL ||
  "https://app.streeteatsrewards.com/registration";
export const DEMO_URL =
  process.env.REACT_APP_DEMO_URL ||
  "https://form.jotform.com/261738085400152";
